import React, { useEffect, useRef, useState, Children } from 'react';
import PropTypes from 'prop-types';

import Icon from '@mdi/react';
import { mdiChevronUp, mdiChevronDown } from '@mdi/js';
import Button from 'client/components/aria/Button/Button';

import styles from './ActionMenu.module.scss';

// TODO - ARIA https://www.w3.org/WAI/ARIA/apg/example-index/menu-button/menu-button-actions.html

const ActionMenu = ({ children, className, label, content, anchor, ...props }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target) && event.target !== buttonRef.current) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClick = () => {
        setOpen((menuOpen) => !menuOpen);
    };

    const buttonRef = useRef(null);

    return (
        <div className={[styles.container, className].join(' ')}>
            <Button
                className={[styles.select, (open ? styles.open : '')].join(' ')}
                onPress={handleClick}
                aria-labelledby={label}
                aria-selected={open}
                aria-haspopup="true"
                aria-expanded={open}
                role="button"
                variant="secondary"
                ref={buttonRef}
                {...props}
            >
                <span className={styles.label}>{content}</span>
                <Icon
                    className={styles.chevron}
                    path={open ? mdiChevronUp : mdiChevronDown}
                    size={1}
                />
            </Button>
            {open && (
                <div
                    ref={ref}
                    className={[
                        styles.content,
                        styles[anchor?.vertical],
                        styles[anchor?.horizontal]
                    ].join(' ')}
                    id={label}
                    role="menu"
                >
                    {children &&
              Children.map(children, (child) =>
                  child &&
                React.cloneElement(child, {
                    onClick: () => {
                        child.props.onClick();
                        setOpen(false);
                    },
                    onKeyPress: (evt) => {
                        if (evt.keyCode === 13 || evt.key === 'Enter') {
                            child.props.onClick();
                            setOpen(false);
                        }
                    },
                    tabIndex: 0
                })
              )}
                </div>
            )}
        </div>
    );
};

ActionMenu.propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    label: PropTypes.any,
    content: PropTypes.any,
    anchor: PropTypes.object
};

ActionMenu.defaultProps = {
    anchor: {
        vertical: 'top',
        horizontal: 'left'
    }
};

export default ActionMenu;
